import {useDispatch, useSelector} from "react-redux";
import {dialogs, eraseEmployees, replaceEmployeesMinMaxPage, setImportCsvDialogAction} from "../../../store/slice";
import {
    getCsvFieldsEmployeesAction,
    GetEmployees,
    GetImportCsvHrManagementTemplate,
    performCsvEmployeesAction
} from "../../../store/actions";
import {TImportCsvDialogProps} from "../../../../../../newShared/components/csvImportDialog";
import {resetImportCsvDialog} from "../../../../../../newShared/components/csvImportDialog/constants";
import {
    useGenericFiltersStorage
} from "../../../../../../newShared/components/genericFilter/hooks/useGenericFiltersStorage";
import {DEFAULT_PAGING} from "../../../../../../newShared/components/genericTable/constants";

export const useImportCsv = (): TImportCsvDialogProps => {
    const dispatch = useDispatch();
    const {importCsvDialog: {
        isOpen,
        isLoading: {
            isGettingFields,
            isPerformingCsv,
            isLoadingTemplate,
        },
        fields,
        fileId,
        response,
    }} = useSelector(dialogs);

    const setImportDialog: TImportCsvDialogProps["setImportDialog"] = (data) => dispatch(setImportCsvDialogAction(data));
    const downloadTemplate = () => {dispatch(GetImportCsvHrManagementTemplate())};
    const getFields: TImportCsvDialogProps["getFields"] = (file) => {dispatch(getCsvFieldsEmployeesAction({
        data: {...file},
        onError: resetImportCsvDialog
    }))};

    const {clearFilters} = useGenericFiltersStorage();

    const performCsv: TImportCsvDialogProps["performCsv"] = (fields) => {fileId && dispatch(performCsvEmployeesAction({
        data: {fields, fileId},
        // snack: "success",
        // onError: (request, error, addictiveData) => {dispatch(setImportCsvDialogAction({error: error[0]?.message || 'Unknown error'}))},
        onSuccess: () => {
            clearFilters();
            dispatch(eraseEmployees());
            dispatch(replaceEmployeesMinMaxPage({minLoadedPage: -1, maxLoadedPage: -1}));
            dispatch(GetEmployees({data: {pageInfo: {page: 0, count: DEFAULT_PAGING, filters: {}}, search: ''}}));
        }
    }))};

    return {
        isOpen,
        isLoadingTemplate, isPerformingCsv, isGettingFields,
        fields,
        setImportDialog,
        downloadTemplate,
        getFields,
        performCsv,
        response,
        fieldsMapperKey: "employees"
    }
}
